import React from 'react';
import { Card, Stencil, Row, Col, Spacer } from '@cleartrip/bento';

function TableLoading() {
	return (
		<>
			<Card className='bc-neutral-100 ba bw-1 px-4 py-3 br-4'>
				<Row className='flex-middle'>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
          <Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
				</Row>
			</Card>
			<Spacer mt={2} />
			<Card className='bc-neutral-100 ba bw-1 px-4 py-3 br-4'>
				<Row className='flex-middle'>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
				</Row>
			</Card>
			<Spacer mt={2} />
			<Card className='bc-neutral-100 ba bw-1 px-4 py-3 br-4'>
				<Row className='flex-middle'>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
					<Col span={4}>
						<Stencil shimmer width='100%' height={20} />
					</Col>
				</Row>
			</Card>
		</>
	);
}

export default TableLoading;
